import { TPAComponentProps } from '../../types';
import { CoreToggleSwitchProps } from '../internal/WixUiCoreComponents/components/CoreToggleSwitch';

export interface ToggleSwitchProps
  extends CoreToggleSwitchProps,
    TPAComponentProps {}
